document.addEventListener('DOMContentLoaded', function () {
  // === STOCK BADGE ===
  const stockEls = [...document.querySelectorAll('#product-stock .stock-status')];
  const inputs   = [...document.querySelectorAll('form [name="id"]')];
  if (stockEls.length && inputs.length) {
    const update = id => {
      stockEls.forEach(el => {
        el.style.display = el.dataset.variantId === String(id) ? 'inline-flex' : 'none';
      });
    };

    const initInput = inputs.find(i => i.checked || i.tagName === 'SELECT') || inputs[0];
    if (initInput) update(initInput.value);

    inputs.forEach(input => {
      input.addEventListener('change', e => update(e.target.value));
    });
  }

});
// ===== REALISTIC VIEWERS WIDGET =====
(function(){
  const el = document.getElementById('viewing-count');
  const widget = document.getElementById('viewing-widget');
  if(!el || !widget) return;

  // --- CHECK STOCK ---
  const inStock = widget.dataset.instock === "true";
  if(!inStock){
    widget.style.display = 'none';
    return;
  }

  // --- DAY / NIGHT MODE ---
  const hour = new Date().getHours();

  let MIN, MAX;

  if(hour >= 23 || hour < 6){
    // NIGHT
    MIN = 1;
    MAX = 5;
  }else{
    // DAY
    MIN = 2;
    MAX = 20;
  }

  const INTERVAL = 10000; // 15 sec

  let current = Math.floor(Math.random()*(MAX-MIN+1)) + MIN;

  function nextValue(){
    let change = Math.floor(Math.random()*6)-3;
    let next = current + change;
    if(next < MIN) next = MIN + Math.floor(Math.random()*2);
    if(next > MAX) next = MAX - Math.floor(Math.random()*2);
    return next;
  }

  function updateColor(val){
    widget.classList.remove('is-warm','is-hot');
    if(val > MAX*0.7) widget.classList.add('is-hot');
    else if(val > MAX*0.5) widget.classList.add('is-warm');
  }

  function update(){
    el.classList.add('viewing-anim');
    setTimeout(()=>{
      current = nextValue();
      el.textContent = current;
      updateColor(current);
      el.classList.remove('viewing-anim');
    },350);
  }

  // INIT
  el.textContent = current;
  updateColor(current);
  setInterval(update, INTERVAL);
})();
// === VENDOR LOGO WIDGET ===
(function() {
  if (!window.vendorLogoData) return;

  const container = document.getElementById('vendor-logo-container');
  if (!container) return;

  const { vendorName, vendorHandle } = window.vendorLogoData;
  if (!vendorName || !vendorHandle) return;

  const loader = document.getElementById('vendor-loader');
  if (loader) loader.remove();

  const base = 'https://cdn.shopify.com/s/files/1/0740/4709/5097/files/';
  const exts = ['webp','png','jpg','jpeg','svg'];

  const collectionText = document.getElementById('vendor-collection-text');
  const vendorLink = '/collections/vendors?q=' + encodeURIComponent(vendorName);

  const setLogo = url => {
    const a = document.createElement('a');
    a.href = vendorLink;
    a.className = 'vendor-logo-link';
    a.style.display = 'inline-flex';
    a.style.alignItems = 'center';

    const img = document.createElement('img');
    img.src = url;
    img.alt = vendorName + ' logo';

    a.appendChild(img);
    container.insertBefore(a, collectionText);
  };

  const tryImg = arr => {
    if (!arr.length) return; // nu afișăm logo dacă nu există
    const url = base + vendorHandle + '.' + arr[0];
    const img = new Image();
    img.onload = () => setLogo(url);
    img.onerror = () => tryImg(arr.slice(1));
    img.src = url;
  };

  tryImg(exts);
})();